<template>
  <event-series-preview>
    <template slot="header">
      <h5 v-if="goalRuleSet && !showLessons">
        {{ trans('series.goal_details') }}
      </h5>
      <h5 v-else-if="numberOfCourses !== 0">
        {{ trans('courses.number_of_lessons') }}: {{ numberOfEvents }}
      </h5>
      <h5 v-else>
        {{ trans('series.preview') }}
      </h5>
    </template>

    <template v-if="!showLessons">
      <template
        v-for="event_serie in event_series"
        :slot="'explanationGroups' + event_serie.id"
      >
        <p>
          {{ trans('series.goals_explanation', { number: numberOfComponents(event_serie.id) }) }}
          {{ trans_choice('series.cluster_goal_explanation', numberPerEventCluster, { number:
            numberPerEventCluster }) }}
        </p>
      </template>
    </template>
  </event-series-preview>
</template>

<script>
import EventSeriesPreview from '../EventSeriesPreview/EventSeriesPreview.vue'

export default {

  name: 'AttendanceGoalPreview',
  components: { EventSeriesPreview },

  computed: {

    showLessons () {
      return this.$store.state.steps.active_step[0]?.lessonSelector === true
    },

    goalRuleSet () {
      return this.$store.state.eventSeries.serie_rules.type != null
    },

    allowShopping () {
      return this.$store.state.eventSeries.serie_rules.allow_shopping
    },

    event_series () {
      return this.$store.state.eventSeries.event_series
    },

    groups () {
      return this.$store.state.eventSeries.groups
    },

    numberOfCourses () {
      return Object.keys(this.$store.state.eventSeries.courses).length
    },

    numberOfEvents () {
      let courses = this.$store.state.eventSeries.course_event_ids
      let number = 0
      Object.values(courses).forEach(course => {
        number = number + course.length
      })
      return number
    },

    numberPerEventCluster () {
      let rules = this.$store.state.eventSeries.serie_rules
      if (rules.type === 'cluster_per_week') {
        return rules.per_week
      }
      return 1
    },
  },

  methods: {
    numberOfComponents (event_serie_id = null) {
      if (!this.goalRuleSet || this.showLessons || Object.keys(this.event_series).length === 0) {
        return null
      } else {
        let event_serie = event_serie_id == null ? this.event_series[Object.keys(this.event_series)[0]] : this.event_series[event_serie_id]
        return Object.values(event_serie.relationships.eventClusters.data).length
      }
    },
  },

}
</script>

<style>
    .event-block {
        border: 1px solid #222;
        padding: 10px 5px;
        margin: 5px 0px;
    }

    .flex-box {
        display: flex;
        flex: 0 0 auto;
        height: 250px;
        flex-direction: column;
        padding: 0px;
        margin-bottom: 0px;
    }

    .flex-header {
        flex: 0 0 50px;
        overflow: hidden;
    }

    .flex-body {
        flex: 1 1 auto;
        overflow: auto;
    }

    .flex-body-component {
        display: flex;
        flex-flow: row nowrap;
    }
</style>
